import { useState } from 'react';
import { truncate } from 'lodash';

import { IconArrowRight } from 'components/Icons';
import Typography from 'components/Typography';

import { useAnalytics } from 'hooks/useAnalytics';
import { Sanitized, sanitize } from 'utils/sanitize';

import { ANALYTICS } from 'analytics/constants';
import { AnalyticClickedLinkDetailsType } from 'analytics/types';
import { CHAT_UI_PREFIX } from 'constants/id';
import { htmlId } from 'utils/html';
import { BUTTON_ACITON_TYPES, MAX_BODY_LENGTH, MAX_TITLE_LENGTH } from '../constants';
import {
  StyledCTA,
  StyledInformationWrapper,
  StyledLeftContentWrapper,
  StyledRightContentWrapper,
} from '../styles';
import { InformationComponentProps } from '../types';
import { open } from 'utils/url';

export const UrlInformation = (
  props: Omit<InformationComponentProps, keyof InformationComponentProps> &
    Pick<InformationComponentProps, 'content'>,
) => {
  const { content } = props;
  const { trackEvent } = useAnalytics();
  const [hover, setHover] = useState(false);

  const htmlContentTitle = truncate(content.title, { length: MAX_TITLE_LENGTH });
  const htmlContentBody = truncate(sanitize(content.body), { length: MAX_BODY_LENGTH });

  const onClick = () => {
    if (BUTTON_ACITON_TYPES.includes(content?.button?.action?.type)) {
      trackEvent({
        analyticEvent: ANALYTICS.EVENT.CLICKED_LINK,
        details: {
          analytic_click_id: `${CHAT_UI_PREFIX}-information-tile-url`,
          content: `${htmlContentTitle} | ${htmlContentBody}`,
          url: content.button.action.url,
        } as AnalyticClickedLinkDetailsType,
      });

      open(content.button.action.url);
    } else {
      // TODO - add error tracking
      console.error(
        'Information Extension: Unrecognized Button Action Type (' +
          content?.button?.action?.type +
          ').',
      );
    }
  };
  return (
    <StyledInformationWrapper
      id={htmlId(`message-extension-url-information`)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={onClick}
    >
      <StyledLeftContentWrapper
        id={htmlId('information-left-content')}
        imageUrl={content.imageUrl}
      />
      <StyledRightContentWrapper id={htmlId('information-right-content')}>
        <Typography as='span' color='strong' variant='heading' size='xs' id='information-title'>
          <div title={content.title}>{htmlContentTitle}</div>
        </Typography>
        <Typography as='span' color='weak' variant='body' size='sm' id='information-content'>
          <div title={content.body}>
            <Sanitized text={htmlContentBody} />
          </div>
        </Typography>
        <StyledCTA id={htmlId('information-tile-cta')} size='xs' hover={hover}>
          <IconArrowRight width='1rem' height='1rem' />
        </StyledCTA>
      </StyledRightContentWrapper>
    </StyledInformationWrapper>
  );
};

export default UrlInformation;
